<template>
  <!-- HOME TIMER CARD -->
  <div v-if="showHomeTimer && !isMobile" class="tc-root">

    <!-- Decorative blobs -->
    <div class="tc-blob tc-blob--1"></div>
    <div class="tc-blob tc-blob--2"></div>

    <!-- Header -->
    <div class="tc-header">
      <div class="tc-header__left">
        <span class="tc-live-dot"></span>
        <span class="tc-header__label">In Progress</span>
      </div>
      <button class="tc-open-btn" @click="atClick(issueData)">
        <v-icon size="13" color="#6366f1">mdi-arrow-top-right</v-icon>
      </button>
    </div>

    <!-- Issue identity -->
    <div class="tc-issue-row">
      <CustomAvatar2
        :size="'small'"
        :fName="issueData.first_Name"
        :lName="issueData.last_name"
        :imgUrl="issueData.n_image_profile_id || null"
        :theme="issueData.theme"
      />
      <div class="tc-issue-info">
        <span class="tc-ref-badge">{{ issueData.reference_num }}</span>
        <span class="tc-issue-name">{{ issueData.name }}</span>
      </div>
    </div>

    <!-- Timer ring + digits -->
    <div class="tc-timer-block">
      <div class="tc-ring-wrap">
        <svg class="tc-ring-svg" viewBox="0 0 160 100">
          <defs>
            <linearGradient id="tc-ring-grad" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stop-color="#a78bfa" />
              <stop offset="100%" stop-color="#34d399" />
            </linearGradient>
          </defs>
          <rect class="tc-ring-track" x="5" y="5" width="150" height="90" rx="12" ry="12" />
          <rect class="tc-ring-fill" x="5" y="5" width="150" height="90" rx="12" ry="12"
            :style="{ strokeDashoffset: secondsProgress }" />
        </svg>
        <div class="tc-ring-inner">
          <span class="tc-timer-digits">{{ getTimerCC || '00:00:00' }}</span>
          <span class="tc-timer-sub">elapsed</span>
        </div>
      </div>
      <button class="tc-stop-btn" @click="timerClicked('home')">
        <span class="tc-stop-icon"></span>
        <span>Stop Session</span>
      </button>
    </div>

    <!-- Meta row -->
    <div class="tc-meta-row">
      <div class="tc-meta-item">
        <span class="tc-meta-label">Est.</span>
        <span class="tc-meta-value">{{ getHourMinutes(issueData.estimate) }}</span>
      </div>
      <div class="tc-meta-divider"></div>
      <div class="tc-meta-item">
        <span class="tc-meta-label">Submitted</span>
        <span class="tc-meta-value">{{ moment(issueData.submitted_date).format('DD MMM') }}</span>
      </div>
      <div class="tc-meta-divider"></div>
      <div class="tc-meta-item">
        <span class="tc-meta-label">Type</span>
        <span class="tc-meta-value tc-type-chip">{{ issueData.issue_type_name }}</span>
      </div>
    </div>

  </div>
  <v-card class="dialogCard" v-if="showCard && !showHomeTimer && !isMobile">
    <v-card-item style="text-align: center">
      {{ time }}
      <!-- <span class="titleMain">Your {{ title=='meeting' && timerName ? timerName :title!='meeting'?timerName.charAt(0).toUpperCase() + title.slice(1):'' }} has
        started</span> -->
      <span class="titleMain">Your
        {{
          title.toLowerCase() == "meeting" && timerName
            ? timerName
            : title.toLowerCase() != "meeting"
              ? title.charAt(0).toUpperCase() + title.slice(1)
              : ""
        }}
        has started</span>

      <span v-if="title.toLowerCase() == 'meeting'" @click="openRemarks()"
        style="position: absolute; top: 0; right: 10px; cursor: pointer" justify="center">
        <i class="pi pi-pencil" style="font-size: 0.7rem; font-weight: 600">
          <v-tooltip activator="parent" location="end">click on me to add notes</v-tooltip>
        </i>
      </span>
    </v-card-item>
    <v-card-text class="mt-4" style="display: flex; justify-content: center">
      <div class="insideCard">
        <div class="my-4">
          <v-img v-if="title.toLowerCase() == 'meeting'" style="display: flex; width: 36px; height: 36px; margin: auto"
            :src="require('@/assets/command.svg')">
          </v-img>
          <v-img v-if="title.toLowerCase() == 'break'" style="width: 24px; height: 24px; margin: auto"
            :src="require('@/assets/image/cupcake.svg')">
          </v-img>
        </div>
        <div class="mb-4" style="display: flex; justify-content: center">
          <span class="timerC">
            {{ getTimerCC }}
          </span>
        </div>
      </div>
    </v-card-text>

    <v-card-actions class="mt-3" style="display: flex; justify-content: center">
      <v-btn>
        <v-img @click="closeDialog()" style="display: flex; width: 36px; height: 36px; margin: auto"
          :src="require('@/assets/image/pause_circle_filled.svg')">
        </v-img>
      </v-btn>
    </v-card-actions>

    <div align="center">
      <div class="px-3">
        <v-textarea v-if="showRemarks" rows="1" label="Remarks" variant="outlined"
          v-model="meetingRemarks" @change="updateRemarks"></v-textarea>
        <v-error v-show="showError">Remarks is required</v-error>
      </div>
    </div>
    <div align="center">
      <div class="mainNote" justify="center" @click="minimizeTimer()">
        Click here to continue your work
      </div>
      <div class="instruction my-3 mx-15 mb-7">
        The timer will continue to clock until you stop this. You can find it in
        the top left corner of the toolbar
      </div>
    </div>
  </v-card>
  <v-chip v-if="!showCard && !showHomeTimer && !isMobile && !showIBT && (getInProgress || showPlay)" label @click="timerClicked"
    :class="timer && timer.seconds > 0 ? type : ''" variant="text" :style="{ color: color ? color : '#272727' }">
    <span v-if="timerData && timerData.type != IBTcode">
      <v-icon v-if="isOkToShowLink && !showCard && !showHomeTimer" @click.stop="openIssue" size="small"
        class="mdi mdi-eye" />
      {{ getTimerCC }}
    </span>
    <v-icon v-if="(((timer && timer.seconds == 0) || !timer) && showPlay) || (timerData && timerData.type == IBTcode)">
      mdi-play
    </v-icon>
    <v-icon v-if="timer && timer.seconds > 0 && timerData && timerData.type != IBTcode"> mdi-pause </v-icon>
    <div style="position: relative; left: 13px; top: 2px" id="meeting-menu-activator" variant="text"
      v-if="timerData && timerData.type == 'meeting' && !showCard && !showHomeTimer" @click.stop="$emit('openDialog')">
      <img class="img1" src="https://new-synergy-snaps.s3.ap-south-1.amazonaws.com/public/icons/command.svg" />
      <v-tooltip activator="parent" location="bottom">Meeting</v-tooltip>
    </div>
  </v-chip>

  <!-- <v-chip
    v-if="showIBT"
    label
    class="in-between-time"
    variant="text"
  >
    <span>
      <b>{{ getTimerCC }}</b>
    </span>
  </v-chip> -->

  <v-dialog v-model="dialogOpen" class="dialogOpen" width="55%" max-width="55%">
    <v-card class="descriptionCard">
      <v-row>
        <v-col cols="4">
          <v-card-title>Description</v-card-title>
        </v-col>
        <v-col class="descBtn">
          <v-btn @click="closeDialog1()" elevation="0" density="comfortable" icon="mdi-close"
            class="x-closeIcon"></v-btn>
        </v-col>
      </v-row>
      <v-card-text v-html="issueData && issueData.description ? issueData.description : ''" />
    </v-card>
  </v-dialog>
</template>
<script>
import { useStopwatch } from "@/composables/useStopWatch";
import moment from "moment";
import lodash from "lodash";
import UserService from "@/api/service/UserService";
import IssueService from "@/api/service/Issue/IssueService";
import TimeSheetService from "@/api/service/TimeSheet/TimeSheetService";
import TimerService from "@/api/service/TimeSheet/TimerService";
import CustomAvatar2 from "@/components/ui/CustomAvatar2.vue";
// import commonService from "@/common.service";
// import HuddleDetailsService from "@/api/service/HuddleDetails/HuddleDetailsService";
// import logicCondition from "@/api/logic/condition";
export default {
  props: [
    "color",
    "title",
    "showHomeCard",
    "timerInProgress",
    "refereshTimeBtn",
    "taskType",
    "showPlay",
    "keyId",
    "hideCard",
    "timerName",
    "showInBetweenTime",
    "showPlayIcon"
  ],
  components: {
    CustomAvatar2,
  },
  data() {
    return {
      showLink: false,
      timer: null,
      type: "issue",
      showTimer: true,
      isMobile: true,
      showRemarks: false,
      showCard: false,
      showHomeTimer: false,
      issueData: {},
      dialogOpen: false,
      showError: false,
      timerData: {},
      meetingRemarks: "",
      showIBT: false,
      IBTcode: process.env.VUE_APP_IBT_CODE
    };
  },
  mounted() {
    this.showIBT = this.showInBetweenTime
    this.checkDevice();
    window.addEventListener('resize', this.checkDevice);
  },
  computed: {
    requiredRule() {
      return (v) => !!v && v.trim().length > 0 || 'This field is required';
    },

    getIssueStatus() {
      return this.$store.getters.getIssueStatus
    },
    getInBetweenTime() {
      return this.$store.getters.getInBetweenTime
    },
    isOkToShowLink() {
      if (this.$store.getters.getIssueViewDrawer) {
        return false;
      } else if (this.$route.path == "/") {
        return false;
      } else if (this.timerData && !this.timerData.issueId) {
        return false;
      } else {
        return true;
      }
    },
    getTimerCC() {
      if (!this.timer || this.timer.seconds == 0) {
        return "";
      } else {
        return this.timer
          ? this.timer.hours +
          ":" +
          this.timer.minutes +
          ":" +
          this.timer.seconds
          : "";
      }
    },
    secondsProgress() {
      const perimeter = 2 * (150 + 90); // 480
      // const topHalf = 75; // half of top edge (150/2)
      const secs = this.timer ? (this.timer.seconds % 60) : 0;
      // At 0s: offset=480 (empty). Grows clockwise from top-middle.
      // Rotate SVG -90deg moves start to left-middle, then we shift by topHalf to reach top-middle.
      return perimeter - (secs / 60) * perimeter;
    },
    getStageStatus() {
      return this.$store.getters.getStageInProgress;
    },
    getInProgress() {
      return this.$store.getters.getInProgress;
    },
    reloadTheData() {
      return this.$store.getters.getReloadTheIssue;
    },
  },
  watch: {
    getInBetweenTime() {
      let timerData = localStorage.getItem("timer");
      this.timerData = timerData ? JSON.parse(timerData) : {};
      console.log('1 ###', this.timerData);
    },
    getInProgress(val) {
      if (!val) {
        // timer was stopped from another instance — reset local state
        this.timerData = {};
        this.showHomeTimer = false;
        if (this.timer) {
          this.timer = useStopwatch(0, true);
          this.timer.pause();
        }
      }
    },
    refereshTimeBtn() {
      let timerData = localStorage.getItem("timer");
      this.timerData = timerData ? JSON.parse(timerData) : {};
      console.log(' ###', this.timerData);
    },
    getIssueStatus() {
      if (this.getIssueStatus && this.getIssueStatus == 2) {
        this.$store.commit("SET_ISSUE_STATUS", null);
        this.updateIssueStatus()
      }
      else if (this.getIssueStatus && this.getIssueStatus == 1) {
        this.startIssueTimer()
      }

    },
    showInBetweenTime() {
      this.showIBT = this.showInBetweenTime
    },
    getStageStatus() {
      if (this.getStageStatus) {
        this.timerClicked();
      }
    },
    getQataskStatus() {
      if (this.getQataskStatus) {
        this.getQAdata();
      } else {
        this.getQAdata();
      }
    },

    timerInProgress() {
      this.getTimer(this.timerInProgress);
    },
    showHomeCard() {
      this.showHomeTimer = this.showHomeCard;
      if (this.showHomeCard) {
        this.getIssueData();
      }
    },
    hideCard() {
      this.showCard = this.hideCard;
    },
    startStopWatch() {
      if (this.startStopWatch) {
        this.startTimer();
      }
    },
    showTimer() {
      if (this.showTimer) {
        this.getTimer(true);
      }
    },
    hideTimer() {
      if (this.hideTimer) {
        this.getTimer(false);
      }
    },
    stopStopWatch() {
      if (this.stopStopWatch) {
        this.stopTimer();
      }
    },
  },
  created() {
    this.showCard = this.hideCard;
    let timerData = localStorage.getItem("timer");
    this.timerData = timerData ? JSON.parse(timerData) : {};
    this.getTimer(false);
    if (this.showHomeCard) {
      this.showHomeTimer = this.showHomeCard;
      this.getIssueData();
    }
    if (this.$route.query.id) {
      let timerData = localStorage.getItem("timer");

      this.timerData = JSON.parse(timerData);
      console.log(timerData, "timerData Dataaaaa");
      if (!timerData) {
        this.showIssueTimeView = true;
      } else if (timerData && timerData.type && timerData.type == "issue") {
        this.showIssueTimeView =
          this.$route.query.id == timerData.issueId ? true : false;
      } else {
        this.showIssueTimeView = true;
      }
    }
    //this.getTimer(true);
  },
  methods: {
    moment,
    checkDevice() {
      this.isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)
      // alert("check")
      // alert(navigator.userAgent)
      // alert(window.innerWidth)
    },
    startIssueTimer() {
      this.showCard = this.hideCard;
      let timerData = localStorage.getItem("timer");
      this.timerData = timerData ? JSON.parse(timerData) : {};
      this.getTimer(false);
      if (this.showHomeCard) {
        this.showHomeTimer = this.showHomeCard;
        this.getIssueData();
      }
    },
    openRemarks() {
      let timerData = JSON.parse(localStorage.getItem("timer"));
      this.meetingRemarks = timerData.remarks;
      this.showRemarks = !this.showRemarks;
    },
    async updateRemarks() {
      // alert('first one')
      // console.log('first one !!')
      this.meetingRemarks = this.meetingRemarks.trim()
      if (this.meetingRemarks && this.meetingRemarks.length > 0) {
        // alert("update remarks")
        let timerData = JSON.parse(localStorage.getItem("timer"));
        // console.log(timerData,"timerData@@@!!!")
        timerData.remarks = this.meetingRemarks;
        localStorage.setItem("timer", JSON.stringify(timerData));
        await TimeSheetService.updateMeetingRemarks({
          user_activity_id: timerData.user_activity_id,
          description: this.meetingRemarks,
          taskCode:timerData.code
        });
      }
    },
    openIssue() {
      let timerData = JSON.parse(localStorage.getItem("timer"));
      if (timerData.issueId) {
        this.$store.dispatch("setIssueInView", timerData.issueId);
      }
    },
    getHourMinutes($minutes) {
      if ($minutes > 59) {
        return `${Math.floor($minutes / 60)} Hr  ${$minutes % 60} mins`;
      } else {
        return `${$minutes} mins`;
      }
    },
    openDialog() {
      this.dialogOpen = true;
    },
    closeDialog1() {
      this.dialogOpen = false;
    },
    atClick(issueData) {
      let selectedId = issueData.id;
      // this.$router.push({ path: "/issueView2", query: { id: selectedId } });
      this.$store.dispatch("setIssueInView", selectedId);
    },
    async getIssueData() {
      let timerData = JSON.parse(localStorage.getItem("timer"));
      if (timerData && timerData.type == "issue" && timerData.issueId) {
        this.showIBT = false
        let res = await IssueService.getIssueData({
          issue_id: timerData.issueId,
        });
        this.issueData =
          res.length > 0 && res[0].ds_issue_list ? res[0].ds_issue_list : {};
        console.log(this.issueData, "checking for details");
      } else {
        this.showHomeTimer = false;
      }
    },
    async timerClicked(type) {
      let timeStatus = this.$store.getters.getTimerStatus;
      if (timeStatus) {
        this.$store.commit('SET_TIME_STATUS', false)
        let status = this.$store.getters.getRefreshTimeSheet;
        if (type && type == "home") {
          this.$emit("workInProgress", true);
          this.$store.commit("SET_REFRESH_TIME_SHEET", !status);
          this.$store.commit("SET_ISSUE_VIEW_DRAWER", false);
        }
        if ((this.timer && this.timer.seconds == 0) || !this.timer || (this.timerData && this.timerData.type == this.IBTcode)) {
          await this.createTimeSheet();
          this.$store.commit("SET_REFRESH_TIME_SHEET", !status);
        } else {
          this.$store.commit("SET_REFRESH_TIME_SHEET", !status);
          let timerData = JSON.parse(localStorage.getItem("timer"));
          if (timerData && timerData.type == "issue") {
            if (type == 'home') {
              this.$store.commit("SET_ISSUE_STATUS", 1);
              this.updateIssueStatus(status, type)
            }
            else {
              // open stage dialog — timer stop happens after dialog via SET_ISSUE_STATUS=2
              this.$emit('update-issue-status')
            }
          } else {
            let timerData = JSON.parse(localStorage.getItem("timer"));
            if (timerData && timerData.code && timerData.remarks_required && timerData.remarks_required == 1 && (!timerData.remarks || timerData.remarks.length == 0)) {
              this.showError = true
              this.showRemarks = true
              this.$emit('openDialog')
            }
            else {
              this.$store.commit("SET_HIDE_TIMER", false);
              this.$emit("closeDialog1", timerData);
              // if (timerData.code == 'HUD') {
              //   let $huddle = JSON.parse(localStorage.getItem('huddle'))
              //   let $hudleData = {
              //     stage: 'completed',
              //     id: $huddle.id,
              //     description: this.meetingRemarks
              //   }
              //   await HuddleDetailsService.update($hudleData)
              //   let $data = { socketName: 'HUDLE_STOPED', huddleId: $huddle.id }
              //   await commonService.getSocketConnection($data)
              // }
              await this.stopTimer();
            }
          }
        }
        this.$store.commit('SET_TIME_STATUS', true)


      }
    },
    async updateIssueStatus(status, type) {
      this.showHomeTimer = false;
      this.$store.commit("SET_REFRESH_TIME_SHEET", !status);
      this.stopTimer(type);
      this.updateTimeSheet(type);
    },
    async closeDialog() {
      let timerData = JSON.parse(localStorage.getItem("timer"));
      if (timerData && timerData.code && timerData.remarks_required && timerData.remarks_required == 1 && (!this.meetingRemarks || this.meetingRemarks.length == 0)) {
        this.showError = true
        this.showRemarks = true
      }
      else {
        if (this.meetingRemarks && this.meetingRemarks.length > 0) {
          timerData.description = this.meetingRemarks;
        }
        this.$emit("closeDialog1", timerData);
        // let $huddle = JSON.parse(localStorage.getItem('huddle'))
        // if (timerData.code == 'HUD') {
        //   let $hudleData = {
        //     stage: 'completed',
        //     id: $huddle.id,
        //     description: this.meetingRemarks
        //   }
        //   await HuddleDetailsService.update($hudleData)
        //   let $data = { socketName: 'HUDLE_STOPED', huddleId: $huddle.id }
        //   await commonService.getSocketConnection($data)
        // }
        this.stopTimer();
      }
    },
    minimizeTimer() {
      this.$emit("closeTimerDialog");
    },
    async createTimeSheet() {
      this.startTimer();
      let userData = JSON.parse(localStorage.getItem("user_details"));
      let data = {};
      let res = await IssueService.findOne(this.keyId);
      data.company_id = userData.company_id;
      data.customer_id = res[0] && res[0].account_id ? res[0].account_id : "";
      data.description = res[0].name;
      data.issue_id = res[0].id;
      data.project_id = res[0].project_id;
      data.task_id = res[0].task_id;
      data.resource_id = userData.id;
      data.stage = "pending";
      if(data.issue_id){
        await IssueService.update({
          id: data.issue_id,
          stage: "inprogress",
        });
      }
      await TimerService.processTime(data, "issue", true);
      this.showIBT = false
      let status2 = this.$store.getters.getReloadTheIssue;
      this.$store.commit("RELOAD_THE_ISSUE", !status2);
      this.$store.dispatch("issueUpdated", this.keyId);
      this.startIssueTimer()
      //await TimeSheetService.create(data);
    },
    async updateTimeSheet() {
      let data = {};
      await TimerService.processTime(data, "issue", false);
      this.$store.commit("SET_ISSUE_STATUS", null);
      // this.stopTimer(type);
      return true
    },
    async updateTimeSheet3() {
      let $timer = JSON.parse(localStorage.getItem("timer"));
      let res = [];
      if ($timer.issueId) {
        res = await TimeSheetService.findAll({
          issue_id: $timer.issueId,
          stage: "pending",
        });
      } else {
        res = await TimeSheetService.findAll({
          task_id: $timer.taskId,
          stage: "pending",
        });
      }
      res = lodash.orderBy(res, ["id"], ["desc"]);
      // alert('Updating time shet')
      let timesheetData = res[0];
      let data = {};
      data.id = timesheetData.id;
      data.end_date = moment(new Date())
        .utcOffset("+05:30")
        .format("YYYY/MM/DD HH:mm:ss");
      let end_date = moment(new Date()).tz("utc");
      let start_date = moment(timesheetData.start_date, true).tz(
        "Asia/Kolkata"
      );
      var hours = end_date.diff(start_date, "seconds") / 60;
      data.stage = "completed";
      data.actual_hrs = hours ? parseFloat(hours.toFixed(2)) : 0;
      // alert(data.stage)
      await TimeSheetService.update(data);
      this.stopTimer();
    },
    getTimer(value) {
      this.type = this.taskType ? this.taskType : "";
      let $timer = JSON.parse(localStorage.getItem("timer"));
      if ($timer) {
        let startTime = JSON.parse($timer.start);
        let endTime = moment(new Date());
        var hours = endTime.diff(startTime, "seconds");
        console.log(hours, "starttimehours", endTime, "start", startTime);
        this.timer = useStopwatch(hours, true);
        this.type = $timer.type;
      } else if (value) {
        this.createTimeSheet();
      } else {
        /* else {
                 let timerStart = JSON.parse(localStorage.getItem("breakormeetingTimer"))
                 if (timerStart) {
                     let endTime = moment(new Date());
                     var hours1 = endTime.diff(timerStart, 'seconds')
                     console.log(hours1, 'starttimehours', endTime, 'start', timerStart)
                     this.timer = useStopwatch(hours1, true);
                 }
             }*/
        // alert('check')
        this.timer = useStopwatch(0, true);
        this.timer.pause();
        // localStorage.removeItem('stopWatchTimer')
        // localStorage.removeItem('stopWatchIssueId')
        // this.$store.commit('SET_IN_PROGRESS', false)
      }
    },
    checkTimer() {
      let timerData = JSON.parse(localStorage.getItem("breakormeeting"));
      if (timerData) {
        this.$emit("openTimer");
      }
    },
    startTimer() {
      this.timer = useStopwatch(true);
      this.timer.start();
      let timerData = JSON.parse(localStorage.getItem("timer"));
      if (!timerData || (timerData && timerData.type == this.IBTcode)) {
        let $start = moment(new Date());
        let $timer = {
          type: this.taskType,
          issueId: this.keyId,
          start: JSON.stringify($start),
        };
        localStorage.setItem("timer", JSON.stringify($timer));
      } else {
        if (timerData && timerData.type == "issue") {
          this.showHomeTimer = true;
        } else {
          this.showHomeTimer = false;
        }
      }
      this.$store.commit("SET_IN_PROGRESS", true);
      this.$store.commit("SET_HIDE_TIMER", false);
    },
    async stopTimer(type) {
      // alert(this.issueData.id)
      let status = this.$store.getters.getPending;
      let timerData = localStorage.getItem("timer");
      timerData = timerData ? JSON.parse(timerData) : {};
      // alert(status)
      if (timerData && timerData.type == "issue" && timerData.issueId) {
        // alert(status)
        if (type && type == 'home') {
          await IssueService.update({
            id: timerData.issueId,
            stage: "pending",
          });
        }
        let status2 = this.$store.getters.getReloadTheIssue;
        this.$store.commit("RELOAD_THE_ISSUE", !status2);
        this.$store.commit("SET_REFRESH_TIME_SHEET", true);
      }
      this.timer = useStopwatch(0, true);
      this.timer.pause();
      localStorage.removeItem("timer");
      this.$store.commit("SET_IN_PROGRESS", false);
      this.$store.commit("SET_HIDE_TIMER", true);
      this.$store.commit("SET_TO_PENDING", !status);

      let userDetails = localStorage.getItem("user_details");
      userDetails = JSON.parse(userDetails);

      UserService.update({
        id: userDetails.id,
        stage: "login",
      });
      let tempTimer = localStorage.getItem("timer");
      this.timerData = tempTimer ? JSON.parse(tempTimer) : {};
      this.showHomeTimer = false;

      // this.timerData = tempTimer
      //   ? JSON.parse(localStorage.getItem("timer"))
      //   : {};
      // console.log("####",this.timerData,tempTimer)
    },
  },
};
</script>
<style scoped>
/* ── HOME TIMER CARD ── */
.tc-root {
  height: 100%;
  background: #ffffff;
  border-radius: 20px;
  border: 1px solid #f1f5f9;
  box-shadow: 0 2px 8px rgba(0,0,0,0.06);
  display: flex;
  flex-direction: column;
  padding: 18px 20px;
  gap: 14px;
  overflow: hidden;
  position: relative;
}

/* decorative blobs */
.tc-blob {
  position: absolute;
  border-radius: 50%;
  pointer-events: none;
  filter: blur(40px);
  opacity: 0.18;
}
.tc-blob--1 {
  width: 120px; height: 120px;
  background: #818cf8;
  top: -30px; right: -20px;
}
.tc-blob--2 {
  width: 80px; height: 80px;
  background: #34d399;
  bottom: 20px; left: -10px;
}

.tc-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  z-index: 1;
}

.tc-header__left {
  display: flex;
  align-items: center;
  gap: 7px;
}

.tc-live-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #4ade80;
  box-shadow: 0 0 0 0 rgba(74,222,128,0.6);
  animation: tc-pulse 2s ease-out infinite;
  flex-shrink: 0;
}

@keyframes tc-pulse {
  0%   { box-shadow: 0 0 0 0 rgba(74,222,128,0.6); }
  70%  { box-shadow: 0 0 0 6px rgba(74,222,128,0); }
  100% { box-shadow: 0 0 0 0 rgba(74,222,128,0); }
}

.tc-header__label {
  font-size: 10px;
  font-weight: 700;
  color: #4ade80;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.tc-open-btn {
  width: 26px;
  height: 26px;
  border-radius: 8px;
  background: #eef2ff;
  border: 1px solid #e0e7ff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.15s;
}
.tc-open-btn:hover { background: #e0e7ff; }

.tc-issue-row {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  position: relative;
  z-index: 1;
}

.tc-issue-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}

.tc-ref-badge {
  font-size: 10px;
  font-weight: 700;
  color: #6366f1;
  background: #eef2ff;
  border: 1px solid #e0e7ff;
  padding: 2px 8px;
  border-radius: 20px;
  letter-spacing: 0.4px;
  width: fit-content;
}

.tc-issue-name {
  font-size: 12px;
  font-weight: 600;
  color: #0f172a;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

/* ── Ring timer ── */
.tc-timer-block {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  flex: 1;
  justify-content: center;
  position: relative;
  z-index: 1;
}

.tc-ring-wrap {
  position: relative;
  width: 200px;
  height: 120px;
  filter: drop-shadow(0 2px 6px rgba(99,102,241,0.2));
}

.tc-ring-svg {
  width: 100%;
  height: 100%;
}

.tc-ring-track {
  fill: none;
  stroke: #e2e8f0;
  stroke-width: 6;
}

.tc-ring-fill {
  fill: none;
  stroke: url(#tc-ring-grad);
  stroke-width: 6;
  stroke-linecap: square;
  stroke-dasharray: 480;
  stroke-dashoffset: 480;
  stroke-dashphase: 75;
  transition: stroke-dashoffset 0.9s ease;
}

.tc-ring-inner {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2px;
}

.tc-timer-digits {
  font-size: 26px;
  font-weight: 800;
  color: #1e293b;
  font-variant-numeric: tabular-nums;
  letter-spacing: 1.5px;
  line-height: 1;
}

.tc-timer-sub {
  font-size: 11px;
  font-weight: 600;
  color: #94a3b8;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.tc-stop-btn {
  display: flex;
  align-items: center;
  gap: 7px;
  padding: 9px 22px;
  border-radius: 50px;
  background: rgba(239,68,68,0.08);
  border: 1px solid rgba(239,68,68,0.3);
  cursor: pointer;
  font-size: 13px;
  font-weight: 700;
  color: #ef4444;
  letter-spacing: 0.3px;
  transition: background 0.15s, box-shadow 0.15s;
}
.tc-stop-btn:hover {
  background: rgba(239,68,68,0.15);
  box-shadow: 0 2px 12px rgba(239,68,68,0.2);
}

.tc-stop-icon {
  width: 8px;
  height: 8px;
  border-radius: 2px;
  background: #ef4444;
  flex-shrink: 0;
}

.tc-meta-row {
  display: flex;
  align-items: center;
  background: #f8fafc;
  border: 1px solid #f1f5f9;
  border-radius: 12px;
  padding: 10px 14px;
  gap: 0;
  position: relative;
  z-index: 1;
}

.tc-meta-item {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 3px;
}

.tc-meta-divider {
  width: 1px;
  height: 26px;
  background: #e2e8f0;
  flex-shrink: 0;
}

.tc-meta-label {
  font-size: 9px;
  font-weight: 700;
  color: #94a3b8;
  text-transform: uppercase;
  letter-spacing: 0.7px;
}

.tc-meta-value {
  font-size: 11px;
  font-weight: 600;
  color: #334155;
  text-align: center;
}

.tc-type-chip {
  background: #f0fdf4;
  color: #16a34a;
  border-radius: 20px;
  padding: 1px 8px;
  font-size: 10px;
  text-transform: capitalize;
}

.issue {
  background-color: #ffe9d0;
  color: #272727;
}

.in-between-time {
  background-color: #fff;
  color: #000;
}

.break {
  background-color: rgb(255, 241, 233) !important;
  color: #272727;
  border: 2px solid rgba(156, 59, 3, 0.5);
}

.meeting {
  background-color: rgba(226, 252, 233);
  color: #272727;
  border: 2px solid rgba(20, 153, 56, 0.5);
}

.meetingBtn {
  border: 2px solid #3c5aaa;
  color: #3c5aaa;
  width: 35%;
}

.titleMain {
  color: #272727;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}

.dialogCard {
  border-radius: 12px !important;
  border: 2px solid #e3e3e3;
  background: #fff;
}

.insideCard {
  border-radius: 12px;
  border: 1px solid #c1e8fc;
  background: #d7eaf4;
  width: 143px;
}

.writeNote {
  color: #01060e;
  /* font-size: 13px; */
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  cursor: pointer;
}

.mainNote {
  color: #1258ab;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  cursor: pointer;
}

.img1 {
  width: 65%;
  background-size: cover;
  height: 100%;
  filter: invert(50%);
}

.instruction {
  color: #000;
  text-align: center;
  font-size: 10px;
  font-weight: 300;
}

.timerC {
  color: #272727;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
</style>